module.exports = {
    navbar: {
        v4overview: "What's new in 4.0",
        home: "HOME",
        v4: "V4",
        install: "INSTALL",
        buy: "BUY",
        mobile: "MOBILE APP",
        individual: "INDIVIDUAL",
        team: "TEAM",
        help: "HELP",
        login: "LOGIN",
        register: "REGISTER",
        forgot_pass: "FORGOT PASSWORD",
        logout: "LOGOUT"
    },
    v4: {
        hero: {
            eyebrow: "Design Mirror V4 · Now available",
            title: "The all-new V4 is here<br><span class=\"text-primary\">available now</span>",
            description: "We rebuilt Design Mirror from the ground up — focused on the #1 pain point: connection reliability. Download it now and try the next-gen live preview.",
            cta: "Download now"
        },
        features: {
            title: "What's new in V4",
            description: "A full rewrite centered on connection reliability, plus brand-new native apps and faster sync.",
            list: [
                {
                    title: "Far more reliable connections",
                    description: "New multi-layer discovery: LAN mDNS → cloud signaling → QR code → USB, with automatic fallback. Works even on locked-down office or complex networks."
                },
                {
                    title: "USB connection (no Wi-Fi)",
                    description: "No usable Wi-Fi or a restricted network? Just plug in a cable and preview live — faster and rock solid."
                },
                {
                    title: "Brand-new native apps",
                    description: "Both iOS and Android were rewritten natively (SwiftUI / Kotlin) — smoother, more battery-friendly, with a reimagined connection flow."
                },
                {
                    title: "One installer, multiple tools",
                    description: "A single desktop install sets up the Photoshop / <b class=\"text-primary\">Illustrator</b> / Sketch / Adobe XD plugins; the Figma / MasterGo / JSDesign plugins ship as a zip — import once and go."
                },
                {
                    title: "Faster live sync",
                    description: "Tile-based delta sync transfers only what changed — quicker updates, less bandwidth, smooth even for long pages."
                },
                {
                    title: "Multi-device preview",
                    description: "Connect several phones / tablets to one computer and compare how your design fits across screen sizes."
                }
            ]
        },
        download: {
            title: "Download Design Mirror V4",
            description: "One desktop installer sets up everything — the Photoshop / Illustrator / Sketch / XD plugins plus the background helper. Then install the mobile app and start previewing.",
            desktop_hint: "Version {version} · restart your design tool after installing",
            items: [
                {
                    key: "windows",
                    icon: "uil-desktop",
                    title: "Windows desktop",
                    description: "Windows 10 / 11. Includes the Photoshop / Illustrator / Sketch / XD plugins and the helper.",
                    button: "Download .exe installer"
                },
                {
                    key: "mac",
                    icon: "uil-apple",
                    title: "macOS desktop",
                    description: "Intel and Apple Silicon (M-series). Includes all plugins and the helper.",
                    button: "Download .pkg installer"
                },
                {
                    key: "android",
                    icon: "uil-android",
                    title: "Android app",
                    description: "Install via Pgyer — open the link in your phone's browser.",
                    button: "Download on Pgyer"
                },
                {
                    key: "ios",
                    icon: "uil-apple",
                    title: "iOS app",
                    description: "Now on the App Store — requires iOS 17.0 or later. Search for “Design Mirror” or tap to download.",
                    button: "Download on App Store"
                }
            ],
            plugins: {
                title: "Figma / MasterGo / JSDesign plugin pack",
                description: "These three plugins aren't on the official plugin marketplaces yet, so they ship as a zip: download, unzip, and import in the tool's desktop client (install the desktop package above first; a README is included).",
                button: "Download plugin pack .zip"
            }
        },
        install: {
            title: "Install & get started",
            description: "Four steps — from install to seeing your design on the phone in minutes.",
            steps: [
                {
                    title: "Install the desktop package",
                    description: "Download the installer for your OS and run it — just click through. The Photoshop / Illustrator / Sketch / XD plugins and the background helper are all set up in one go."
                },
                {
                    title: "Install the mobile app",
                    description: "On iPhone, install from the App Store (requires iOS 17.0 or later). On Android, open the Pgyer page in your phone's browser and install (allow the install if prompted)."
                },
                {
                    title: "Open your design tool & the plugin panel",
                    description: "Restart your design tool, then open the plugin: Photoshop / Illustrator — Window → Extensions (Plugins) → Design Mirror; Sketch — Plugins → Design Mirror; XD — Plugins → Design Mirror."
                },
                {
                    title: "Connect automatically & preview",
                    description: "With the phone and computer on the same network, the app discovers your computer automatically — tap to connect. On complex networks it falls back to the cloud channel, QR code, or a USB cable."
                }
            ],
            web_plugins: {
                title: "Figma / MasterGo / JSDesign: import the plugin pack",
                description: "Unzip the plugin pack, then import it once in the tool's desktop client (pick the manifest.json in the matching folder):",
                items: [
                    "Figma: Plugins → Development → Import plugin from manifest… — pick figma/manifest.json, then run it from Plugins → Development → Design Mirror",
                    "MasterGo: Plugins → Developer mode → Add plugin — pick mastergo/manifest.json",
                    "JSDesign: Plugins → Developer → Import plugin — pick jsdesign/manifest.json"
                ],
                note: "The desktop client is required — the browser version can't reach the local helper."
            }
        },
        contact: {
            title: "Ran into an issue? Talk to the developer",
            description: "Run into an issue or have an idea? Send it straight to me. Scan to add me on WeChat, note \"V4\".",
            qrhint: "Scan with WeChat · note \"V4\"",
            fallback: "If the QR doesn't work, email: xiaoqiang@cutterman.cn"
        }
    },
    footer: {
        description: "Live preview your design with Photoshop/XD/Sketch/Figma",
        link: "Links",
        links: [
            {
                text: "Terms",
                link: "/terms"
            },
            {
                text: "Privacy Policy",
                link: "/privacy"
            },
        ]
    },
    index: {
        title: "LIVE PREVIEW YOUR DESIGN",
        description: "preview your design on a phone from Photoshop, Illustrator, Sketch, XD, Figma, MasterGo and JSDesign",
        install: "Start",
        video: "Demo Video",
        photoshop: "Plugin embed in Photoshop, without open third-party software to switch. Support Artboards, pixel perfect preview, support Mac and Win.",
        xd: "Support preview with Adobe XD, no Creative Clouds files needed. Both Android & iphone devices are able to connect",
        sketch: "Plugin in Sketch makes it possible to preview in Android devices. USB and Wifi connections are both supported.",
        figma: "Newly support with Figma on both browser and App, more convenient then official one",
        feature1: {
            title: "All platforms",
            description: "Design Mirror runs on win and mac, and provide same features on both ios and android devices.",
            details: [
                "Windows/Mac support",
                "Photoshop / Illustrator / Sketch / XD / Figma / MasterGo / JSDesign",
                "iphone/android/web preview support",
                "Connect with multi devices at same time"
            ]
        },
        feature2: {
            title: "Connect through WIFI",
            description: "When App and Desktop connect in to the same WIFI network, connection will establish automatic. Multiple devices are supported to connect at the same time.",
            details: [
                "Devices auto detected, also support manual ip input",
                "Multiple devices support, mobile phone or pads",
                "Preview with qrcode scanning without login",
            ]
        },
        feature3: {
            title: "Connect through USB",
            description: "Connect your device to computer with USB cable, connection will establish through usb. This is extreamly useful when your network is down. USB connection is more smoothly and stability.",
            details: [
                "Plug with usb cable and there you go",
                "Useful when no network available",
            ]
        },
        app: {
            title: "Amazing Features",
            description: "checkout these powerful features in Design Mirror",

            features: [
                {
                    title: "Pinch to zoom",
                    description: "You can pinch to zoom your design when need. some useful preview modes are provided."
                },
                {
                    title: "Swipe to change Artboards",
                    description: "You can swipe to navigate artboards/documents, or select one by name."
                },
                {
                    title: "Screenshot & Save design",
                    description: "Take a screenshot when you wanna save a design on your mobile phone."
                },
                {
                    title: "Upload images",
                    description: "Transfer image from phone to Photoshop/Sketch never so easy."
                },
                {
                    title: "Offline artboards",
                    description: "Artboards previewed are saved in app, you can check it anytime."
                },
                {
                    title: "Share your design",
                    description: "Easy share your design with in app share button."
                }
            ]

        },
        signup: {
            title: "现在就开始使用吧",
            description: "免费注册账号，享受多平台多终端丝滑体验",
            email: "请输入邮箱地址",
            button: "注册账号"
        },
        price: {
            title: "Trial & Price",
            description: "You have 15 days free trial. after that you need purchase a license to continue.",
            plans: [
                {
                    title: "Six Month",
                    currency: "$",
                    price: 7.9,
                    sku_id: 13,
                    type: 0,
                    period: "/6Month",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                {
                    title: "One Year",
                    currency: "$",
                    sku_id: 14,
                    type: 0,
                    price: 14.9,
                    period: "/Year",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                {
                    title: "Two Years",
                    currency: "$",
                    price: 28,
                    type: 0,
                    sku_id: 15,
                    isBest: true,
                    period: "/2Years",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                {
                    title: "Group",
                    currency: "",
                    sku_id:14,
                    type: 2,
                    price: 20,
                    period: "% OFF",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                /*
                {
                    title: "企业用户",
                    currency: "",
                    sku_id:100,
                    price: 60,
                    period: "/年",
                    feature: [
                        "不限平台/设计软件",
                        "单一账号登录，方便管理",
                        "10人以上8折优惠",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                 */
            ],
            enterprise: {
                title: "Enterprise/Team",
                description: "Team or Enterprise license is suitable for team or company. You can purchase a license for your team or company, and have an admin to manage all accounts.",
                price: "Price： 14.9$/Year/Account",
                feature: [
                    "member management",
                    "Ps/XD/Sketch/Figma",
                    "Technology support",
                    "Free updates",
                ],
                button: "Buy",
            }
        },
        price_11: {
            title: "Trial & Price",
            description: "You have 15 days free trial. after that you need purchase a license to continue.",
            plans: [
                {
                    title: "Six Month",
                    currency: "$",
                    price: 7.9,
                    sku_id: 13,
                    type: 0,
                    period: "/6Month",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                {
                    title: "One Year",
                    currency: "$",
                    sku_id: 14,
                    type: 0,
                    price: 14.9,
                    period: "/Year",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                {
                    title: "Two Years",
                    currency: "$",
                    price: 28,
                    type: 0,
                    sku_id: 15,
                    isBest: true,
                    period: "/2Years",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                {
                    title: "Group",
                    currency: "",
                    sku_id:14,
                    type: 2,
                    price: 20,
                    period: "% OFF",
                    feature: [
                        "Ps/XD/Sketch/Figma",
                        "Technology support",
                        "Personal use only",
                        "All Features",
                        "Free updates",
                    ],
                    button: "Buy",
                },
                /*
                {
                    title: "企业用户",
                    currency: "",
                    sku_id:100,
                    price: 60,
                    period: "/年",
                    feature: [
                        "不限平台/设计软件",
                        "单一账号登录，方便管理",
                        "10人以上8折优惠",
                        "技术支持",
                        "免费升级",
                    ],
                    button: "购买",
                },
                 */
            ]
        },
        contact: {
            title: "Contacts",
            description: "Contact us when anything goes wrong",
            follow_title: "Follow us",
            details: [
                {
                    title: "Slack",
                    description: "Click link below to join our Slack group and get helps",
                    more: "<a class='text-primary' target='_blank' href='https://join.slack.com/t/designmirror/shared_invite/zt-11lp9jyhf-h5KLwZGchkzJ5CxWw6bw4A'>Join Slack Group >></a>"
                },
                {
                    title: "Twitter",
                    description: "Follow or leave message via Twitter",
                    more: "<a class='text-primary' target='_blank' href='https://twitter.com/UI_DesignMirror'> Follow >></a>"
                },
            ]
        }
    },
    signup: {
        title: "NEW ACCOUNT",
        email: "Email",
        emailTip: "a valid email",
        password: "Password",
        passwordTip: "at least 6 digits",
        accept: "I Accept",
        terms: "Service Terms",
        signup: "Submit",
        captcha: "Captcha",
        captcha_tip: "input right code",
        refresh_captcha: "Switch",
        haveAccount: "Have an account?",
        signIn: "Login",
        token: {
            title: "One more step!",
            description: "We have send an email to <span class='badge badge-info'>{email}</span> with a passcode, please open your mailbox and input the passcode",
            token_tip: "passcode",
            done: "Complete",
            resend_token: "resend email",
            resend_tip: "Resent<br/> can resend after 60s",
            success: "Registration Complete..."
        }
    },
    login: {
        title: "LOGIN",
        email: "Email",
        emailTip: "a valid email",
        password: "Password",
        passwordTip: "at least 6 digits",
        forgot_pass: "Forgot password?",
        no_account: "No account?",
        signup: "Register",
        login_success: "Login success...",
        modal: {
            title: "Login your account"
        }
    },
    reset_pass: {
        title: "RESET PASSWORD",
        description: "Please input your Email account to get a passcode mail",
        emailSend: "Has sent a mail with verify code to <strong>{email}</strong>, please check your mail an input the code below.",
        email: "Email",
        emailTip: "your email account",
        newPass: "New Password",
        send: "Send",
        submit: "Submit",
        successTip: "Pass reset success!",
        remember: "Remember your password?",
        login: "Login"
    },
    photoshop: {
        title: "Photoshop plugin",
        description: "See the live preview and your device's connection state right inside Photoshop.",
        version_support: "Apple Silicon and Intel both supported; CC2018 or newer",
        download: "Download",
        version: "Version:",
        update_time: "Update:",
        install: {
            title: "Installation Guide",
            description: "One installer, three steps",
            step1: {
                title: "Download and install Design Mirror",
                detail: "Use the button above to get the pkg (Mac) or exe (Windows) and click through the installer; macOS will ask for your password. The package is notarized by Apple, so the \"unidentified developer\" block no longer appears. This single installer sets up the background helper and the panels for Photoshop, Sketch, XD and Illustrator — nothing else to download."
            },
            step2: {
                title: "Open the panel",
                detail: "Restart Photoshop and open Menu -> Window -> Extensions -> Design Mirror, then sign in.\nIf it isn't there — common on recent Photoshop versions, especially on Apple Silicon — look under Menu -> Plugins instead. Adobe moved the extensions entry there in the 2022 release, and only one of the two locations exists on any given install.\nThe helper starts with your machine and needs no attention."
            },
            step3: {
                title: "Connect your phone",
                detail: "Install the Design Mirror app (4.0 or newer). On the same Wi-Fi it is discovered automatically; otherwise scan the QR code in the panel, or just plug in a USB cable."
            }
        }
    },
    sketch: {
        title: "Sketch plugin",
        description: "Preview straight from Sketch — the official preview app is no longer needed.",
        version_support: "* Works with every Sketch version — no version-specific build to pick",
        download: "Download",
        install: {
            step1: {
                title: "Install and open the plugin",
                detail: "What you download is a pkg installer, not a .sketchplugin file. Double-click and click through; it is notarized, so macOS will not block it. Restart Sketch and open Menu -> Plugins -> Design Mirror, then sign in.\nThe 4.0 plugin is no longer split by Sketch version — one installer covers every release, so there is no version-specific download to hunt for.\nThe same installer also sets up the Photoshop, XD and Illustrator panels."
            }
        }
    },
    xd: {
        title: "Adobe XD plugin",
        description: "Live preview works in XD too.",
        version_support: "* Please use an up-to-date XD",
        download: "Download",
        install: {
            title: "Steps",
            steps: [
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'xd']);\"  class=\"badge badge-primary\" >Click here <i class=\"uil uil-file-download\"></i></a> to download the Design Mirror installer and run it. <strong>Since 4.0 the XD plugin is bundled inside it — there is no separate .xdx download any more.</strong> That is all — <strong>there is no window to keep open</strong>. The 4.0 helper is a background service that starts with your machine (the old version needed its desktop client kept running; this one does not).",
                "Restart XD and open Menu -> Plugins -> Design Mirror",
                "Install the Design Mirror app (4.0 or newer) on your phone; on the same Wi-Fi it is found automatically, or scan the QR code in the panel"
            
            ],
            step: {
                title: "Download and install",
                detail: "One installer sets up the background helper and the XD plugin, along with the Photoshop, Sketch and Illustrator panels."
            }
        }
    },
    illustrator: {
        title: "Illustrator plugin",
        description: "Adobe Illustrator is supported as of 4.0 — preview your artboards live on a phone.",
        version_support: "Illustrator CC2014 or newer",
        download: "Download",
        install: {
            title: "Steps",
            steps: [
                "Use the button above to download the Design Mirror installer and run it. <strong>The Illustrator plugin is bundled inside — there is nothing else to download.</strong>",
                "Restart Illustrator and open Menu -> Window -> Extensions -> Design Mirror, then sign in",
                "Install the Design Mirror app (4.0 or newer) on your phone; on the same Wi-Fi it is found automatically, or scan the QR code in the panel, or just plug in a USB cable"
            ]
        }
    },
    figma: {
        title: "Figma plugin",
        description: "Yes, Design Mirror now supports Figma",
        download: "Download",
        install: {
            title: "Installation",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://www.figma.com/community/plugin/1021010214021436737/Design-Mirror\">click here <i class=\"uil uil-external-link-alt\"></i></a> to install figma plugin",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'figma']);\"  class=\"badge badge-primary\" >Click here <i class=\"uil uil-file-download\"></i></a> to download the desktop Design Mirror helper (now 4.0) and run it. That is all — <strong>there is no window to keep open</strong>. The 4.0 helper is a background service that starts with your machine (the old version needed its desktop client kept running; this one does not).",
                "Open the Figma plugin, install the Design Mirror app (4.0 or newer) on your phone, and they pair automatically on the same Wi-Fi"
            ]}
    },
    mastergo: {
        title: "MasterGo plugin",
        description: "Use Design Mirror inside <strong>MasterGo</strong>",
        download: "Download",
        install: {
            title: "Steps",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://mastergo.com/community/plugin/88358893523396\">Click here <i class=\"uil uil-external-link-alt\"></i></a> to install the plugin from the official plugin store",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'mastergo']);\"  class=\"badge badge-primary\" >Click here <i class=\"uil uil-file-download\"></i></a> to download the desktop Design Mirror helper (now 4.0) and run it. That is all — <strong>there is no window to keep open</strong>. The 4.0 helper is a background service that starts with your machine (the old version needed its desktop client kept running; this one does not).",
                "Open the MasterGo plugin, install the Design Mirror app (4.0 or newer) on your phone, and they pair automatically on the same Wi-Fi"
            ]}
    },
    jsdesign: {
        title: "JSDesign plugin",
        description: "<strong>JSDesign</strong> works with Design Mirror too",
        download: "Download",
        install: {
            title: "Steps",
            steps: [
                "<a target='_blank' class=\"badge badge-primary\" href=\"https://js.design/community?category=detail&type=plugin&id=641aed2ff131d9846a1f1edc\">Click here <i class=\"uil uil-external-link-alt\"></i></a> to install the plugin from the official plugin store",
                "<a id=\"download-url\" href=\"javascript:void(0)\" onclick=\"_czc.push(['_trackEvent', 'app', 'download', 'jsdesign']);\"  class=\"badge badge-primary\" >Click here <i class=\"uil uil-file-download\"></i></a> to download the desktop Design Mirror helper (now 4.0) and run it. That is all — <strong>there is no window to keep open</strong>. The 4.0 helper is a background service that starts with your machine (the old version needed its desktop client kept running; this one does not).",
                "Open the JSDesign plugin, install the Design Mirror app (4.0 or newer) on your phone, and they pair automatically on the same Wi-Fi"
            ]}
    },
    mobile: {
        title: "Mobile App",
        description: "iPhone, Android and the WeChat mini program are supported; you can also just scan the QR code with your phone's browser.<br/><br/><strong>Make sure you are on 4.0 or newer</strong> — 4.0 on the desktop uses a new connect ladder (LAN, cloud signalling, QR code, USB) that older app builds cannot answer. Search for <strong>design mirror</strong> in your app store.",
        modal: {
            title: "Get the app",
            detail: "Search the App Store for <strong>Design Mirror</strong>, or use the button below. Make sure it is <strong>4.0 or newer</strong>.<br/>For Android, use the <strong>Android App</strong> button instead.",
            appstore: "Open the App Store"
        },
        feature: {
            title: "Features",
            description: "The app makes live preview convenient"
        }
    },
    buy: {
        title: "PRICE",
        description: "You may have 15 days trial with full features. After that, you should buy a license to continue.",
        member_tip_title: "老用户权益变更",
        member_tip: "从2022/1/1日起，本产品由原先的单平台终身付费方式，改为全平台支持订阅付费制，已购买单平台终身制的用户请<a class='badge badge-dark' href=\"/member-update\">点击这里</a>查看权益变更细则。"
    },
    help: {
        title: "Help & Support",
        list: [
            {
                title: "Ps plugin installation",
                id: "ps",
                detail: [
                    "<strong>Download and install the plugin\n</strong>",
                    "Download the plugin installer for the Photoshop version from the official website (https://www.psmirror.cn/). Currently, the plugin supports a minimum of the CC2018 version. Before installation, please make sure that your Ps version meets the requirements. If the version is too low, please update Ps to the latest first.",
                    "<strong style='color: red'>Note: When downloading, there is no need to specify win/mac, as the page has automatically matched the different system installation packages based on your operating system.</strong>",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_1.png\" alt=\"\" />",
                    "After unzipping the downloaded compressed package, you will find the installer. Double-click to open the installer and just click \"next\" throughout the process. " +
                    "<strong style='color: red'>Note: When installing on a Mac system, you may encounter a warning box indicating that the installation cannot be completed, as shown below.</strong>",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_2.png\" alt=\"\" />",
                    "This is because the Mac system has not enabled the installation permission for third-party developers. Please follow these steps: Mac system -> Preferences -> Privacy -> General, and click \"Open Anyway\" at the bottom." +
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_3.png\" alt=\"\" />",
                    "<strong>2. Open the plugin panel</strong>" +
                    "After installation, restart Ps, and you can open the plugin panel through the menu bar -> Window -> Extensions.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_4.png\" alt=\"\" />",
                    "<strong style='color: red'>Note: If you are using a Mac computer with an M1 chip and the latest Ps 2021/2022 version, you will find that the option for Extensions mentioned above is missing. This is because the new version has deprecated the old plugin architecture by default. You can open it as follows:</strong>",
                    "Find the application -> Adobe Photoshop 2022 -> Adobe Photoshop 2022 -> Right-click and Show Properties -> Check \"Open with Rosetta\" and restart Ps, you will then be able to see the Extensions entry.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_5.png\" alt=\"\" />",
                ]
            },
            {
                title: "Sketch plugins installation",
                id: "sketch",
                detail: [
                    "hen we need to link Sketch for preview, we need to install a plugin on Sketch. Please note that the plugin is only supported by Sketch version 70 and computers with M1 chips.",
                    "<strong>1. Download and install the plugin</strong>",
                    "Download the plugin installer for the sketch version from the official website (https://www.psmirror.cn/sketch). Please note that the plugin is only supported by Sketch version 70. Before installation, please confirm that your Sketch version meets the requirements. If the version is too low, please upgrade Sketch to the latest version first.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_6.png\" alt=\"\" />",
                    "After unzipping the downloaded package, you will have the installation program. Note that the plugin installation program is a .pkg file, not the common Sketch plugin format (*.sketchplugin). Just double-click on the installation program and follow the steps.",
                    "<strong style='color: red'>Note: On Mac systems, during installation, a warning box may pop up saying that the installation cannot be completed, as shown below.</strong>",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_2.png\" alt=\"\" />",
                    "This is because the Mac system has not enabled the installation permission for third-party developers. Please follow these steps: Mac system -> Preferences -> Privacy -> General, and click \"Open Anyway\" at the bottom." +
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_3.png\" alt=\"\" />",
                    "<strong>2. Open the plugin panel</strong>",
                    "After installation, restart Sketch and you can open the plugin panel in the Menu bar -> Plugins -> Mirror Live Preview.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_9.png\" alt=\"\" />",
                    "Then log in to your account to start the preview. If you do not have an account, please register on the official website first.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_8.png\" alt=\"\" />",
                    "Note that during the preview, you need to keep the panel open. If you finish previewing, you can close the plugin panel."
                ]
            },
            {
                title: "XD plugins installation",
                id: "xd",
                detail: [
                    "When we need to link Adobe XD for preview, we need to install the plugin on Adobe XD, which supports the Adobe XD version and computers with M1 chips.",
                    "<strong>1. Download and Install the Plugin</strong>",
                    "Download the plugin installation program from the official website (https://www.psmirror.cn/xd), make sure to unzip the downloaded file and double-click the installation program to complete the installation.\n" +
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_10.png\" alt=\"\" />",
                    "<strong>2. Open the plugin panel</strong>",
                    "After the installation process is completed, restart XD and open Design Mirror through the computer's application.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_11.png\" alt=\"\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_12.png\" alt=\"\" />",
                ]
            },
            {
                title: "Figma plugins installation",
                id: "figma",
                detail: [
                    "Figma preview requires the installation of both the Figma plugin and the desktop client.",
                    "<strong>1. Download and Install the Plugin</strong>",
                    "a. Click on <a href='https://www.figma.com/community/plugin/1021010214021436737/Design-Mirror' target='_blank'>this link</a> to enter Figma's official plugin market, and click on \"Install.\"",
                    "b. Download the installation program from the website (https://www.psmirror.cn/figma), extract it after it's downloaded, and double-click the installation program to complete the installation.",
                    "<strong>2. Open the plugin panel</strong>",
                    "Open the plugin panel from Figma",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_13.png\" alt=\"\" />",
                    "After the installation process is completed, open Design Mirror through the computer's application.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_11.png\" alt=\"\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_12.png\" alt=\"\" />",
                    "Note that during the preview, you need to keep the panel open. If you finish previewing, you can close the plugin panel."
                ]
            },
            {
                title: "Wifi Connection Issues",
                id: "wifi",
                detail: [
                    "<strong>1. Confirm Plugin Installation</strong>",
                    "Open the plugin panel, if you are able to update the design map normally, it means the plugin installation is normal, continue with the following steps. If the plugin preview is also not normal, it may indicate that there is a problem with the plugin installation, please try to reinstall the plugin.",
                    "If the Ps plugin panel shows that Photoshop is not connected, as shown below, this may be due to a VPN or network proxy being opened locally. If so, please close the VPN and restart PS. If there is no VPN open locally, close the plugin first and then restart PS.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_14.png\" alt=\"\" />",
                    "<strong>2. Confirm if the phone and computer are connected to the same network</strong>",
                    "a.  You can check the IP address on the homepage of the App and compare it with the computer's IP to see if they are connected to the same network.",
                    "<strong style='color: red'>Note: Sometimes even if they are connected to the same WiFi, the two devices may connect to different routers and cross different segments, which will also result in the inability to connect. For example, if the computer's IP is 192.168.0.10 and the phone's IP is 192.168.1.12, the third field 0/1 is different, which is a cross-segment situation.</strong>",
                    "b. Observe the IP displayed on the homepage. If 0.0.0.0 is displayed, it means that the phone is currently not connected to the WiFi, it may be connected to 4G or something similar, or the App may not have obtained the network permission. In this case, you can turn off and turn on the WiFi, check the system settings, see if the App's network permission has been turned on. Finally, kill the App and open it again.",
                    "<strong>3. Try entering the IP manually</strong>",
                    "You can manually enter the phone's IP in the plugin panel during the App connection process (during the connecting circle animation process)." ,
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_15.png\" alt=\"\" />",
                    "<strong>4. Turn off your computer's firewall</strong>",
                    "Sometimes the firewall on Windows systems can prevent other devices from connecting. You can try turning off the system firewall and trying again.",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_16.png\" alt=\"\" />",
                    "<img width='100%' src=\"https://static.cutterman.cn/static/mirror/images/mirror_help_17.png\" alt=\"\" />",
                    "<strong>5. Try using USB connection</strong>",
                    "Sometimes, office networks have restrictions, even though they are connected to the same network and subnet, communication between devices may still be impossible. At this time, only USB connection can be used for preview."
                ]
            },
            {
                title: "USB Connection issues",
                id: "usb",
                detail: [
                    "<strong>1.Check the plugin installation.</strong>",
                    " If the plugin panel is able to update the design normally, the plugin is installed correctly. If not, try reinstalling the plugin. Make sure the software is up-to-date." ,
                    "<strong>2. Windows + Android</strong>",
                    "Ensure the Android phone is in debug mode. Install a phone assistant software to see if the phone is recognized. If using 360 assistant, it is recommended to uninstall it as it may occupy the USB connection channel.",
                    "<strong>3. Windows + iphone</strong>",
                    " Install iTunes on the computer, which can be downloaded from the official website (https://www.apple.com.cn/itunes/). Open iTunes after installation to automatically recognize the phone. If the phone is not recognized, try reinstalling iTunes. iTunes doesn't have to be open while connecting.",
                    "<strong>4. Mac + iphone/android</strong>",
                    "Mac systems do not require additional dependencies for USB connection. If there is a problem with the connection, it may be an issue with the cable or interface, try changing the USB cable or interface."
                ]
            },
            {
                title: "Payment-related questions",
                id: "pay",
                detail: [
                    "<strong>1. Is this software paid?</strong>",
                    "Yes, the software provides a 15-day trial period during which you can use it to your heart's content and purchase it if you feel it's appropriate. The features during the trial period are the same as after purchasing.",
                    "<strong>2. What is the payment model?</strong>",
                    "The software uses a subscription-based license. You need to purchase after the trial period in order to continue using it.",
                    "Subscription licenses are available at different prices based on half-year, one-year, and two-year packages. A subscription is not tied to any one design tool — it covers Ps, Illustrator, Sketch, XD, Figma, MasterGo and JSDesign for as long as it runs.",
                    "<strong>3. What rights do members have?</strong>",
                    "In addition to basic software usage, members receive free product upgrades and exclusive technical support with priority problem resolution. There will be no issue of the eye-straining issue with the link." ,
                    "<strong>4. How to purchase?</strong>",
                    "Go to the official website https://www.psmirror.cn, click the purchase link in the navigation, enter the purchase interface, and choose the subscription package you want to purchase. Currently, only Alipay payment is supported.",
                ]
            },
            {
                title: "Contact us",
                id: "contact",
                detail: [
                    "<strong>Contact us</strong>",
                    "Follow or leave message via Twitter <a href='https://twitter.com/UI_DesignMirror' target='_blank'>@UI_DesignMirror</a>",
                    "Or send email to <a href='mailto:qiang0902@gmail.com'>qiang0902@gmail.com</a>"
                ]
            }
        ]
    },
    member: {
        title: "权益变更说明",
        description: "针对已购买过终身授权的用户",
        overview: {
            title: "变更说明：",
            content: "至<b class='text-danger'>2022年3月1日</b>起，Design Mirror授权方式，从之前的<strong class='text-primary'>单平台终身授权</strong>更换为<strong class='text-primary'>全平台订阅授权</strong>方式。对于已经购买过某平台下终身授权的用户，涉及到已购买的授权是否发生变化和将要购买其它平台时如何付费等问题，下文将详细说明。",
            title1: "名词解释",
            content1: "<b>单平台终身授权</b>指的是每个平台(Ps/Sketch/XD/Figma）需要单独购买，一次购买终身使用。",
            content2: "<b>全平台订阅授权</b>指的是按照时间订阅的方式进行购买授权，购买后该账号在<b>全部设计软件</b>上都可以使用，不限平台（Ps / Illustrator / Sketch / XD / Figma / MasterGo / 即时设计）。",
            title3: "已购的授权是否有效？",
            content3: "已经购买过的终身授权，继续有效，仅对该平台终身有效。",
            title4: "购买其它平台如何授权？",
            content4: "购买新平台的授权，将采用订阅授权的方式，订阅授权针对所有剩余未购买的平台有效。",
            title5: "老用户优惠政策",
            content5: "为感谢老用户信任与支持，对已购买过某平台授权的用户，购买其它平台订阅授权享受首年优惠政策：",
            desc1: "1. 已经购买了Ps&Sketch&XD三个平台终身授权的用户，不再需要购买Figma，自动终身使用",
            desc2: "2. 已经购买了任意两个平台终身授权的用户，购买剩余两个平台的订阅授权，首年享受<b class='text-danger'>4折优惠</b>",
            desc3: "3. 已经购买了任意一个平台终身授权的用户，购买剩余三个平台的订阅授权，首年享受<b class='text-danger'>6折优惠</b>",
            desc4: "4. 2/3两个优惠政策，仅针对<b class='text-danger'>标准套餐</b>有效"
        },
        faq: {
            title: "常见问题：",
            list: [
                {
                    q: "我已经购买了Ps的终身授权，是不是也要变成订阅按年付费？",
                    a: "不会，已经购买过的终身授权，依然有效。",
                },
                {
                    q: "我已经购买了Ps的终身授权，购买Sketch是否要按年付费？是否会影响我的Ps终身授权？",
                    a: "购买新的平台，都将采用订阅付费方式，但不会影响已购买的终身授权平台。即 Ps 依然终身使用，新购买的订阅授权对其余全部设计软件生效。",
                },
                {
                    q: "我已经购买了Ps和Sketch和XD三个平台的终身授权，是否还需要购买Figma？",
                    a: "不用，为感谢用户的支持，已经购买过3个平台终身授权的用户，自动赠送Figma的终身授权。",
                },
                {
                    q: "我购买了的账号，可以和别人共用么？",
                    a: "不能，账号仅自己使用，一个账号会有登录设备的限制，超过设备登录会导致功能无法链接，账号被列入异常等。",
                }
            ]
        }

    },
    cart: {
        title: "Order Information",
        param_error: "param error",
        order: {
            name: "Product",
            description: "Detail",
            price: "Price",
            number: "Count",
            created_at: "Time",
            total: "Total",
            checkout: "Paypal",
            not_exists: "Order not found, redirect to last page"
        },
        group_order: {
            title: "Group users",
            name: "One year license",
            email: "Account",
            add: "Add group user",
            add_button: "Add",
            remove: "Remove"
        },
        status_title: "Payment status",
        status_success: "Success",
        status_fail: "Failed",
        repay: "Try again",
        success: {
            title: "Order Completed",
            detail: "Thank you! You can re login you app to make license active.",
        },
        fail: {
            title: "Order not complete",
            detail: "If anything wrong with the payment, please contact us immediately.",
        },
        home: "Home",
        qq: "官方QQ群",
        weixin: "微信公众号",
        weibo: "官方微博"
    },
    profile: {
        email_invalid: "Account is not verified, please verify you email in setting page.",
        info: {
            title: "Basic",
            description: "basic account information",
            email: "Email",
            status: {
                title: "Account status",
                non_active: "Not verified",
                non_active_tip: "Verify you email in setting page",
                active: "Normal",
                block: "Locked",
                block_tip: "Account locked, please contact us to unlock"
            },
            name: "Name",
            phone: "Phone",
            no_phone: "unset",
            no_phone_tip: "can be use to find password lost",
        },
        profit: {
            title: "License",
            description: "Your license list of current",
            app: "App",
            auth_status: "Status",
            auth_trial: "Trial",
            auth_expired: "Expired",
            auth_subscribe: "Subscribed",
            auth_lifetime: "Licensed",
            end_time: "Expire Time",
            purchase_time: "License Time"
        },
        order: {
            title: "Order",
            description: "Your orders",
            ticket: "需要开具发票？",
            ticket_title: "如何开具发票",
            ticket_detail: "微信扫描二维码加入官方群，联系群主开具发票。",
            id: "Order Num.",
            name: "Name",
            detail: "Detail",
            price: "Price",
            created_at: "Time",
            status: "Status",
            buyer: "Payer",
            operation: "Op",
            pay: "Pay",
            delete: "Delete",
            status_0: "UnPaid",
            status_1: "Paid",
            status_2: "Paying",
            status_3: "Closed",
            status_4: "Refund",
        },
        device: {
            title: "Access",
            description: "Here list your access devices",
            app: "App",
            os: "os",
            mac: "MAC/IP",
            created_at: "Time",
            name: "ID",
            op: "Operation",
            remove: "Delete",
            modal_ok: "Submit",
            modal_title: "Customize ID",
            name_tip: "must be words/digits/-_.@#",
            format_error: "not correct format"
        },
        enterprise: {
            title: "Enterprise",
            description: "Here list your enterprise members, including email and password, you can modify them as you want.",
            name: "Name",
            members: "Members",
            save: "Save",
            quota: "Quota",
            add_quota: "Add Quota",
            email: "Email",
            password: "Password",
            last_access_time: "Access Time",
            action: "Operation",
            cancel: "Cancel"
        },
        setting: {
            title: "Setting",
            email: "Email",
            email_tip: "* email must be verified after modified",
            name: "Name",
            phone: "Phone",
            avatar: "Avatar",
            save: "Save changes",
            select_avatar: "Select",
            upload_avatar: "Upload ",
            change_password: "Change Password",
            new_password: "New password",
            new_password_repeat: "New password again",
            save_password: "Save",
            password_tip: "at least 6 number",
            select_done: "Done",
            select_cancel: "Cancel",
            upload: "Done",
            upload_tip: "Select/Drag an image here(<1M)",
            password_info: "* all devices will be logout after change password",
            email_validate: "Verify Email",
            email_validate_tip: "Your must verify your email to continue",
            send_code: "Send passcode",
            code_input_tip: "Passcode has be sent to <span class='badge badge-info badge-pill'>{email}</span>，please open your mail box and input the six number passcode below.",
            code_submit: "Submit",
            code_resend: "Resend"
        },
        logout: {
            title: "Logout"
        }
    },
    terms: {
        title: "服务协议",
        time: "更新时间： 2022年2月7日",
        description: ["Design Mirror是由北京灵动无线网络科技有限公司(以下简称“灵动无线” 或“我们”)提供的互联网软件服务(以下简称“本产品”)。本服务协议(以 下简称“本协议”)是您(以下简称“您”或“用户”)与灵动无线之间关于您访问和使用Desing Mirror以及灵动无线提供的其他服务的协议。", "在本服务创建账户并使用之前，您必须首先同意本协议。在接受本协议之前， 请您仔细阅读全部内容，如您无法准确理解或不同意本协议的任一内容，请不要访问、使用我们提供的其他任何服务。您通过网络⻚面点击确认、 实际购买或使用本服务等操作均表示您已阅读并充分理解本协议之内容，具有达成本协议所需的民事权利能力和民事行为能力(或您符合本协议中“青少年特别协议”部分的要求)，与灵动无线就使用或订购相应产品和/或服务已达成合作意向，并同意接受本协议的全部约定内容，受其约束。","特别提示您关注本协议关于限制、免除灵动无线责任的协议、对用户的权利限制协议、违规/违约行为的认定处理、以及管辖法院的选择等协议内容，前述协议可能以加粗及/或加下划线形式提示您注意。", "您同意灵动无线有权不时地对本协议进行修订。修订后的协议将在网⻚上公布的方式向您告知，并代替原来的服务协议。您继续访问和使用本产品即视为您接受修订后的服务协议。如您不同意修订后的全部或者部分服务协议内容，您有权通过停止访问本网站或者拒绝使用相应软件服务等方式以终止服务协议或者使修订后的内容不对您生效。", "如果您代表某个机构而非您个人注册、登录和使用本产品，则您将被认为获得该机构的充分授权，有权代表该机构同意本服务协议以及服务协议不时的修改和补充。"],
        content: [
            {
                title: "服务内容",
                content: [
                    "本协议中的“本产品”指:灵动无线向您提供psmirror.com网站(即官网)上所展示的产品和服务，包括但不限于通过网⻚、移动端APP等方式提供的全部服务，具体服务内容以您所使用或订购的内容为准。",
                    "若您未从灵动无线官方途径获取服务的，我们无法保证该服务能够正常使用，我们对此种获取方式和使用行为造成的损失不承担任何责任。",
                    "根据实际需要和灵动无线不时提供的其他服务内容，我们可能与您另行签订其他协议(“其他协议”)。同时，即使未另行签订其他协议，您使用本产品的具体服务也将被视为您同意我们关于该等具体服务的任何要求。如果其他协议和本协议之间存在冲突，应以其他协议为准，但以该冲突和与该协议特定事宜相关为限。",
                    "灵动无线保留随时变更、中止或终止部分免费服务的权利，并保留根据实际情况随时调整本产品提供的免费服务种类、形式的权利。灵动无线不承担因本产品提供的任何免费服务的调整给您造成的损失。灵动无线有权在未来恰当的时机对任何免费服务内容收取相应的服务费用。灵动无线做出上述调整前会以站内通知、邮件或官网公告等方式通知您，并给予您合理期限以完成数据的下载和备份。免费版服务可能在功能或者体验上有所限制，您可以通过开通付费版解除该等限制，具体信息以官网描述为准",
                    "您在使用本产品服务前，应充分阅读并理解本产品官网对相应服务的描述，尤其是对免费服务、各级收费服务在功能、服务标准上的限制。对由于您未能充分理解上述描述和限制而造成的任何损失，我们不承担任何法律责任。"
                ]
            },
            {
                title: "账户",
                content: [
                    "为使用本产品，您必须注册一个账户。注册账户时，您需要提供真实、准确的信息。如果您的信息发生变更，请及时在您的账户中对信息进行更新。您对(a)您的账户的保密性，以及用于启用您访问服务的任何密码、身份验证密钥或安全凭据的安全性负责，和(b)所有在您账户下的活动，不论是您还是您的最终用户的活动负责。如果您的账户下有任何未经授权或滥用行为或者任何与服务相关的安全事件，请您立即通知我们。您认可并同意我们不会对您账户中任何未经授权或滥用行为负责，除非这是由我们违反本协议所造成的。",
                    "灵动无线和您应遵守相关法律法规进行实名认证。就本产品的使用，灵动无线可能要求您提供进一步的身份资料、经营资质和信息，以完成身份认证或资格验证。仅在完成相应身份认证及资格验证后，您才可以订购及使用相关服务。您理解并同意灵动无线有权自行或委托第三方，审查您在实名认证时提供的信息是否真实、准确及有效，对于违反本协议约定的账户信息，灵动无线有权采取不予通过、屏蔽或删除等处理。您知晓并同意，如您未依照相关法律法规及灵动无线的要求完成实名认证，将影响您访问或使用本服务。",
                    "您声明并保证，您向灵动无线提供的信息均为真实、准确、有效、最新的，否则您应承担由此产生的一切法律责任。尽管有前述规定，灵动无线无义务对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核 实任何登记资料的真实性、准确性、完整性、适用性及/或是否为最新资料的责任。",
                    "灵动无线建议您妥善保管您的注册邮箱、手机号、密码和名称，准确输入该等信息将作为您访问登录本产品并享有服务的关键环节。如果您发现有人未经授权使用您的账户信息或怀疑任何人未经授权可能能够访问您的私有内容，您应立即更改密码，并向我们反馈。",
                ]
            },
            {
                title: "使用",
                content: [
                    "您声明并保证您上传或储存在本产品中的内容不违反本协议并且符合法律法规。您应对您上传或储存的内容的合法性、准确性、完整性和可靠性负责。 您应负责获得并持续保有任何与您的内容相关的通知、同意或授权。除非 法律另有明确规定，否则灵动无线不承担任何与您上传或储存的内容有关的义务和责任。若您在本产品上传、储存侵犯他人知识产权或其他违法、违规的内容，灵动无线有权利予以删除并保留移交司法机关处理的权利。",
                    "您不得使用本产品上传、储存、共享、发送或传播任何敏感信息和违反国家 法律法规的信息，包括但不限于下列信息:<br/>" +
                    "- 反对宪法所确定的基本原则的;\n<br/>" +
                    "- 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的; - 损害国家荣誉和利益的;\n<br/>" +
                    "- 煽动⺠族仇恨、⺠族歧视，破坏⺠族团结的;\n<br/>" +
                    "- 破坏国家宗教政策，宣扬邪教和封建迷信的;\n<br/>" +
                    "- 散布谣言，扰乱社会秩序，破坏社会稳定的;\n<br/>" +
                    "- 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;\n<br/>" +
                    "- 侮辱或者诽谤他人，侵害他人合法权益的;\n<br/>" +
                    "- 含有法律、行政法规禁止的其他内容的。\n<br/>" +
                    "  您承诺发表言论要:爱国、守法、自律、真实、文明。不传播任何非法的、\n<br/>" +
                    "骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽 的、危害国家安全的、泄露国家机密的、破坏国家宗教政策和⺠族团结的 以及其它违反法律法规及政策的内容。若您的行为不符合以上提到的服务协议。我们将作出独立判断立即暂停或终止您的服务账号。您需自行对其全部行为承担法律责任，我们不承担任何法律责任。",
                    "您不得发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商 业秘密等合法权利的内容。",
                    "您不得制作、复制、发布、传播涉及他人隐私、个人信息或资料的信息。",
                    "您不得发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的内容。",
                    "您应当对您使用本产品的一切行为及所有在您账户下的活动(不论是您还是您授权他人的活动)负责。您不得利用本产品从事违反法律法规、违反本用户协议约定、危害网络安全、危害计算机系统安全、破坏产品完整性或其他侵害任何第三人利益的活动。若您从事了上述行为，灵动无线有权暂停或终止您的账户，并拒绝您于现在和未来使用本产品，由此对灵动无线或第三人造成的损失或由此产生的一切法律责任均由您全部承担。"
                ]
            },
            {
                title: "内容和知识产权",
                content: [
                    "您在本产品提交的内容之所有权归您所有。您明白灵动无线对您提供的任何内容不在任何方面负责，灵动无线没有义务预先审查此类内容。但是，我们有权随时决定您提供的任何内容是否符合相关法律规定或本协议的相关约定，并可随时预先审查、转移、拒绝、修改和/或删除您上传的内容，而不需事先通知您。若您使用本服务的行为存在或涉嫌任何违反国家法律法规或侵犯任何第三方合法权益的情形，灵动无线有权直接删除该等违反规定的信息，并可以暂停或终止向您服务。",
                    "本产品的所有权及所有与本产品服务相关的知识产权(包括但不限于源代码、目标代码、文档资料、界面设计、版面框架、以及任何由灵动无线根据维护与技术支持提供的软件、资料等)归灵动无线所有。您认同灵动无线拥有的所有权及知识产权，并承诺尊重及不以任何方式侵害灵动无线对本产品享有的所有权及知识产权。未经灵动无线书面许可，您不能复制、拷⻉、 转让、许可或提供他人使用上述知识成果，或者私自使用任何部分代码和外观设计，否则您应承担相应的法律责任，且灵动无线有权终止服务且不退还任何费用。"
                ]
            },
            {
                title: "隐私政策",
                content: [
                    "您在使用本产品前，通过阅读和点击同意《隐私政策》并实际使用本服务，即表示您授权灵动无线合法收集和使用有关您及您所使用本服务的技术性或诊断性信息。基于提供服务所必需，手机端用户仅在用于反馈建议和问题时调用录音、拍照、读取相册等权限。收集到的这些信息将用于改进本产品服务的内容和技术，提升我们的服务品质。灵动无线不会将您的信息和内容分享或出售给第三方。但以下情况除外:<br/>" +
                    "- 基于特定的服务目的且事先获得您的明确授权;\n<br/>" +
                    "- 遵守适用的法律法规;\n<br/>" +
                    "- 遵守法院命令或其他法律程序的规定;\n<br/>" +
                    "- 遵守相关政府主管部⻔的要求;\n<br/>" +
                    "- 与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的情 形下;\n<br/>" +
                    "- 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信 息公开等渠道;\n<br/>" +
                    "- 灵动无线认为为遵守适用的法律法规、维护社会公共利益、或保护灵动无线的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需 的情形下;\n<br/>" +
                    "- 您违反了本服务协议，且灵动无线出于维权需要向第三方提供的情形 下;\n<br/>" +
                    "- 法律法规规定的其他情形。<br/>",
                    "保护用户个人信息是灵动无线的一项基本原则，灵动无线将按照《隐私政策》的约定收集、使用、储存和分享您的个人信息，以及您如何管理您的个人信息、我们如何采取必要措施保障您的个人信息安全、我们响应您的权利请求等。您声明并保证，您已仔细阅读、完全理解并同意上述 《隐私政策》的全部内容。若您不同意本协议及《隐私政策》， 请您立即停止使用我们提供的任何服务或产品。"
                ]
            },
            {
                title: "数据和信息安全",
                content: [
                    "我们与您共同负有维护账号安全的责任。我们在目前的技术水平下努力保护您的账号在服务器端的安全，并不断更新技术措施。但互联网并非绝对安全的环境，我们特别提醒您应该妥善保管您的账号和密码，杜绝私自转借乃至出售账号等有害于账号安全的行为。此外，灵动无线建议您采用复杂字符组合设定您的账号密码。请您理解，灵动无线不对因您自身有违相关法律法规规定和本协议约定使用账号的行为及其所导致的数据未经授权访问、泄露、破坏乃至销毁等造成的损失承担责任。",
                    "灵动无线将依照法律、行政法规的规定和国家标准的强制性要求，采取合理的技术措施和其他必要措施，努力保护您的数据和信息安全。但是，互联网数据传输、存储、转换均可能存在一定未知且不确定的数据安全⻛险，该等⻛险将导致包括但不限于数据丢失、泄露、损坏、无法读取或提取等后果。您确认，您已明确知晓并同意接受该等因互联网引发的⻛险和后果， 并已采取恰当的措施(例如数据备份等)，以便在该等⻛险发生时将损失 降至最低。",
                    "您知悉并认可，本产品服务是基于第三方云服务所提供的SAAS服务，鉴于网络服务的特殊性(包括但不限于云服务器的稳定性问题、通讯基础设施 故障、网络黑客攻击、政府管制等行为的存在及其他我们无法控制的情形)，我们提供的服务可能会出现中断、不能及时传送信息或其他不能满足您的要求的情况，请您知悉并理解，该情况将不视为我们违反本协议约定，但我们将尽可能及时通过网页公告、系统通知、短信或者其他合理的方式通知您。"
                ]
            },
            {
                title: "免责声明",
                description: "您知悉并同意，下列情况下，灵动无线无需向您承担任何责任:",
                content: [
                    "由于您维护不当或保密不当，导致数据、资料、口令、密码等丢失或泄漏，或其他非因灵动无线原因导致的个人信息的泄漏，灵动无线不承担任 何法律责任;",
                    "任何由于不可抗力、黑客攻击、电脑病毒侵入、网络运营商原因或政府管制等灵动无线无法合理控制的原因而造成本产品使用中止、中断、延误、使用限制、使用异常、使用不能、暂时性网站关闭等，灵动无线不承担任何法律责任;",
                    "您应对通过本产品上传或储存文件、输入数据的合法性以及获得文件、数 据、内容的方式的合法性负责，因上述文件、数据、内容引发的一切纠纷，由您承担全部法律责任，灵动无线不承担任何法律责任;",
                    "互联网是一个开放平台，如果您将图片、文字等内容上传并传播，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，您应充分意识 到此类⻛险的存在。您同意使用灵动无线服务所存在的此类⻛险及后果将完全由您自己承担，灵动无线不承担任何责任。",
                    "您理解并确认，受技术所限，灵动无线无法保证其所提供的服务毫无瑕疵，但我们承诺将不断提升服务质量及服务水平，为您提供更加优质的服务。据此，您同意:如果灵动无线所提供的服务虽然存在瑕疵，但该等瑕 疵是当时行业技术水平所无法避免的，其将不被视为违约，灵动无线无须因此向您承担任何责任。",
                    "我们通过中华人民共和国境内的设施提供服务，我们无法确保您的使用行为、发布的信息及内容在其他国家或地区是适当的、可行的，当您在其他 司法辖区使用本软件及相关服务时，您应自行确保其遵守当地的法律法规，我们对此不承担任何责任。",
                    "如我们发现、或通过第三方举报或投诉获知，您发布的内容存在或涉嫌违反国家法律法规或本软件规则的，我们有权依据合理判断不经通知立即采取一切必要措施(包括但不限于立刻删除您所发布的相关内容、冻结账户封号、向公安机关报案等)或配合国家网信部门、公检法等国家机关的执法要求对帐户做相应处理以减轻或消除您行为所造成的影响。"
                ]
            },
            {
                title: "服务变更/中断/终止",
                content: [
                    "您可随时注销您的账户并停止使用本产品服务。注销账户的方式可遵照官网的指引。您声明并保证，在您自主注销账户前已经将您上传、储存在本产品中的数据下载、备份完毕。您自主注销账户并经过缓冲期后，我们将不再负有保留您数据的任何法定或者约定义务。",
                    "您理解并同意，如因系统维护或升级的需要而暂停本产品服务、调整服务功能的，灵动无线将尽可能事先在网站上进行通告，以便于您提前做好商业安排，努力将对您带来的实际影响降到最低，但不因此承担任何法律责任。",
                    "当出现如下任一情形时，灵动无线可径行终止或暂停您使用所有或部分账 户和/或本服务<br/>" +
                    "- 您提供的资料不真实，或违反其他用户个人资料提供规则;\n<br/>" +
                    "- 您违反法律法规、本协议或您与灵动无线的其他约定;\n<br/>" +
                    "- 您要求取消或终止您的账户;\n<br/>" +
                    "- 未经灵动无线同意，将本产品产品用于商业目的或者其他任何营利性用 途;\n<br/>" +
                    "- 您对本产品的访问或使用可能会对本产品服务、灵动无线或第三方造成安全 ⻛险;\n<br/>" +
                    "- 需要听从法庭传票、法律命令或遵循法律程序;\n<br/>" +
                    "- 根据相关法律法规或政府机构的要求;\n<br/>" +
                    "- 因自然灾害、战争等不可抗力;\n<br/>" +
                    "- 本协议发生变更或修改，您不同意变更或修改后的用户协议。<br/>",
                    "您理解并认可，为技术升级、服务体系升级、或因经营策略调整或配合国 家重大技术、法规政策等变化，灵动无线不保证永久地提供某种服务，或可能变更所提供服务的形式、规格或其他方面，在终止该种服务或进行此种变更前，灵动无线将尽最大努力且提前以网站公告、站内信、邮件或短信等一种或多种方式进行事先通知;如终止提供该种服务的，灵动无线将尽合理的努力给您预留合理的时间，妥善处理后续事宜。",
                    "一旦您的账户被终止，您将无法正常使用本服务。此外，您可以选择在账户终止前删除您的账户下的所有信息和内容。"
                ]
            },
            {
                title: "本服务协议的完善和修改",
                content: [
                    "灵动无线有权根据互联网的发展和中华人⺠共和国有关法律、法规的变化， 不时地完善和修改本协议。灵动无线保留随时修改本协议的权利，并会将修改后的服务协议在官网上公布，您有义务及时查看官网上的消息更新，该等公布行为即可被合理地视为对您进行了有效通知送达。您在使用灵动无线的服务时，有必要对最新的《服务协议》进行仔细阅读和重新确认，经您确认和同意后，当发生相关争议时，以最新的服务协议为准。",
                    "如果您不同意灵动无线对本协议所做的修改，您应立即停止使用本产品服务。如果用户继续使用本产品服务，则视为用户接受我方对本协议所做的修改。"
                ]
            },
            {
                title: "⻘少年特别协议",
                content: [
                    "本产品服务主要面向成年人。若您是未成年人，请您确保您的监护人已仔细阅读、理解并接受本协议。并在征得您的监护人同意的前提下使用本产品服务或向灵动无线提供信息。",
                    "如您的监护人不同意您按照本协议使用本服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。",
                    "您声明并保证，您是具有完全⺠事行为能力的自然人。若您违背上述保证购买、使用本产品付费服务的，灵动无线不因此承担任何包括但不限于返还价款在内的任何法律责任，由此造成的损失应由您或您的监护人自行承担。"
                ]
            },
            {
                title: "法律适用及争议解决",
                content: [
                    "本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用 中华人⺠共和国大陆法律;如法律无相关规定的，参照商业惯例或者行业惯例",
                    "您因使用本产品服务所产生及与本协议有关的一切争议，由灵动无线与您协商解决。协商不成时，任何一方均可向灵动无线住所地人⺠法院提起诉讼。",
                    "若用户利用本服务从事任何违法或侵权行为，由用户自行承担全部责任，灵动无线不承担任何法律责任。因此给灵动无线或任何第三方造成任何损失的，用户应负责全额赔偿。"
                ]
            },
            {
                title: "联系我们",
                content: [
                    "当您有其他的投诉、建议或反馈时，请与我们联系。您可以将您的问题发送至 xiaoqiang@cutterman.cn，或通过官网提供的联系渠道与我们反馈。",
                    "北京灵动无线网络科技有限公司",
                    "邮箱： xiaoqiang@cutterman.cn",
                    "QQ：687356463",
                    "微博： cutterman"
                ]
            }
        ]

    },
    privacy: {
        title: "隐私政策",
        time: "更新时间 2022年02月07日",
        content: []
    }

}
